module.exports = __webpack_public_path__ + "static/media/01.690624f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diy/01.mp4
// module id = Un4w
// module chunks = 15